import styled from "styled-components"

import ButtonCss, {ButtonCssProps} from "@irati/ui/src/Button/styled"

export default styled.a<ButtonCssProps>`
  ${ButtonCss}
`
